import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../store/reducers/store';
import { Box, Pagination, PaginationItem } from '@mui/material';
import { setPage } from '../../store/actions/libraryOfFunds';

const ListOfFundsPagination: React.FC = () => {
    const funds = useAppSelector(state => state.libraryOfFundsReducer.funds?.length);
    const currentPage = useAppSelector(state => state.libraryOfFundsReducer.page);
    const dispatch = useAppDispatch();

    const onChangePage = (page: number) => {
        dispatch(setPage(page - 1));
    }

    useEffect(() => {
        if (funds && currentPage >= funds / 3) {
            dispatch(setPage(currentPage - 1));
        }
    }, [funds, currentPage, dispatch]);

    if (funds === undefined) {
        return <></>
    }

    return <Box padding={"20px"}>
        <Pagination page={currentPage + 1} count={Math.floor((funds + 7) / 8)} color='primary' onChange={(props, value) => onChangePage(value)}
            hideNextButton hidePrevButton renderItem={(item) => (
                <PaginationItem {...item}  />
            )} />
    </Box>; //sx={{ fontSize: "16px", fontWeight: "400", "&.Mui-selected": { backgroundColor: item.selected ? theme.palette.common.white : undefined, boxShadow: theme.shadows[1] } }}
}

export default ListOfFundsPagination;